import PropTypes from 'prop-types';
import { ICON_PLACEMENTS, DESCRIPTION_PLACEMENTS } from './constants';
import { iconsList } from '../icon/glyphs';
import { TYPES } from '../icon/constants';

export const ActionListItemProps = {
  title: PropTypes.string.isRequired,
  size: PropTypes.oneOf(['small', 'medium']),
  description: PropTypes.string,
  flagCode: PropTypes.string,
  iconGlyph: PropTypes.oneOf(iconsList),
  disabled: PropTypes.bool,
  selected: PropTypes.bool,
  onClick: PropTypes.func,
  component: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
  noninteractive: PropTypes.bool,
  descriptionPlacement: PropTypes.oneOf(Object.values(DESCRIPTION_PLACEMENTS)),
  iconPlacement: PropTypes.oneOf(Object.values(ICON_PLACEMENTS)),
  iconType: PropTypes.oneOf(Object.values(TYPES)),
  withBetaLabel: PropTypes.bool,
  contentRight: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
};
